import { c as _c } from "react/compiler-runtime";
import { useAnalyticsSkuViewedContext } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed/Context';
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
export const useCompareCheckboxAnalyticsEvents = () => {
  const $ = _c(7);
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  let t0;
  if ($[0] !== skuImpressionId) {
    t0 = {
      actionName: "compare_card",
      actionSection: "ru_product_card_compare",
      actionType: "select",
      additionalAttributes: {
        sku_impression_id: skuImpressionId
      }
    };
    $[0] = skuImpressionId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const fireCheckCheckboxPageAction = usePageAction(t0);
  let t1;
  if ($[2] !== skuImpressionId) {
    t1 = {
      actionName: "compare_card",
      actionSection: "ru_product_card_compare",
      actionType: "unselect",
      additionalAttributes: {
        sku_impression_id: skuImpressionId
      }
    };
    $[2] = skuImpressionId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const fireUncheckCheckboxPageAction = usePageAction(t1);
  let t2;
  if ($[4] !== fireCheckCheckboxPageAction || $[5] !== fireUncheckCheckboxPageAction) {
    t2 = {
      select: fireCheckCheckboxPageAction,
      unselect: fireUncheckCheckboxPageAction
    };
    $[4] = fireCheckCheckboxPageAction;
    $[5] = fireUncheckCheckboxPageAction;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};